import React from 'react';
import styles from './ThreeDots.module.scss';

const ThreeDots = ({ size = 12, color = '#0D3B66', className = '' }) => {
    return (
        <div className={`${styles.wrapper} ${className}`} role="status" aria-label="Loading">
            <span
                className={styles.dot}
                style={{
                    width: size,
                    height: size,
                    backgroundColor: color,
                    animationDelay: '0s',
                }}
            />
            <span
                className={styles.dot}
                style={{
                    width: size,
                    height: size,
                    backgroundColor: color,
                    animationDelay: '0.2s',
                }}
            />
            <span
                className={styles.dot}
                style={{
                    width: size,
                    height: size,
                    backgroundColor: color,
                    animationDelay: '0.4s',
                }}
            />
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};

export default ThreeDots;
